import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { PersonCommentDTOBase } from "./PersonCommentDTOBase";
import type { PersonStaff } from "./PersonStaff";
import type { ProfilePersonBase } from "./ProfilePersonBase";
import type { TrackedBase } from "./TrackedBase";

export class PersonCommentStaff implements PersonCommentDTOBase, TrackedBase, ProfilePersonBase {
  constructor(public readonly commentId: number, public readonly author: string, public readonly comments: string, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly personId: PersonStaff | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonCommentStaffPersonId(this.commentId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
